import { DashRegistrationStep } from '@/types/dashboard';
import { defaultScreeningProgress, type IScreeningProgressModel } from '@/types/screening/screening-progress';

export interface IScreeningAcceptability {
    isAcceptable: boolean;
    includeBmiNotice: boolean;
    isOverseasRuleOut: boolean;
    hasHardErrors: boolean;
    hardErrors: string[];
    offerRuleOutTransfer: boolean;
    softErrors: string[];
    offerProjectDonorWeightLossProgram: boolean;
}

export interface IScreeningResultsModel extends IScreeningProgressModel {
    isDirectedDonor: boolean;
    siteName: string;
    donorAcceptability: IScreeningAcceptability;
}

export const defaultScreeningResultsModel: IScreeningResultsModel = {
    ...defaultScreeningProgress,
    currentRegistrationStep: DashRegistrationStep.ScreeningComplete,

    isDirectedDonor: false,
    siteName: '',
    donorAcceptability: {
        isAcceptable: false,
        includeBmiNotice: false,
        isOverseasRuleOut: false,
        hasHardErrors: false,
        hardErrors: [],
        offerRuleOutTransfer: false,
        softErrors: [],
        offerProjectDonorWeightLossProgram: false,
    },
};
